
!function ($) {

	'use strict';

	var __id = 0;

	function Tooltip($container) {
		this._init($container);
	}

	Tooltip.prototype = {

		_spacer: 10,

		_rtl: /\s?rtl\s?/i,
		_rev: /\s?reverse\s?/i,

		_init: function ($container) {

			this.$container = $($container);
			this.bind();
		},

		_click: function (e) {
			if ($(e.target).attr('data-toggle') == 'click') {
				e.preventDefault();
			}
		},

		_down: function (e) {

			var $t = $(e.target);

			if ($t.is('.mk-tooltip')
				|| $t.closest('.mk-tooltip').length) {
				return;
			}

			this.hide();

			if (!$t.is('.mk-tooltip-trigger')) {
				$t = $t.closest('.mk-tooltip-trigger');
			}

			if ($t.length && $t.attr('data-toggle') == 'click') {
				this.show($t);
				this._trackDialogFocus($t, this._findTooltip($t));
			}
		},

		_over: function (e) {

			var $t = $(e.target);

			if ($t.attr('data-toggle') == 'click') {

				this._findTooltip($t);

				if (e.type == 'focusin') {
					var me = this;
					$t.on('keydown.mk-tooltip', function (e) {
						me._keypress(e, $t);
					});
				}
				return;
			}
			this.hide();
			this.show($t);
		},

		_out: function (e) {

			var $t = $(e.target);

			if ($t.attr('data-toggle') == 'click') {
				if (e.type == 'focusout') {
					$t.off('keydown.mk-tooltip');
				}
				return;
			}
			this.hide($t);
		},

		_keypress: function (e, $t) {

			if (e.which == 13 || e.which == 32) {

				e.preventDefault();

				this.hide();
				this.show($t);

				var $tip = this._findTooltip($t);
				this._trackDialogFocus($t, $tip);
			}
		},

		_trackDialogFocus: function ($t, $tip) {

			var $killer = $tip.find('button.mk-tooltip-killfocus');

			if (!$killer.length) {

				var me = this;

				$killer = $('<button class="mk-tooltip-killfocus sr-only" aria-hidden="true" tabindex="-1"></button>');
				$killer.on('focus.mk-tooltip', function () {
					me.hide();
					$t.focus();
				});
				$tip.append($killer);
			}
		},

		_getContainer: function () {

			if (!this.$tipsContainer) {

				var $c = this.$container.find('.mk-tooltip-container');

				if (!$c.length) {
					$c = $('<div class="mk-tooltip-container" />');
					$c.appendTo(this.$container);
					this.$tipsContainer = $c;
				}
			}
			return this.$tipsContainer;
		},

		_findTrigger: function (el) {

			if (typeof el == 'number') {
				return $(this.$container.find('.mk-tooltip-trigger')[parseInt(el, 10)]);
			}
			return $(el);
		},

		_findTooltip: function ($t) {

			var $tip = $('#' + $t.attr('aria-describedby'));

			if (!$tip.length) {

				if ($t.attr('data-title')) {
					$tip = $('<div class="mk-tooltip" />').text($t.attr('data-title'));
				}
				else {

					$tip = $t.find('.mk-tooltip');

					if (!$tip.length) {
						$tip = $t.parent().find('.mk-tooltip');
					}
				}
				this._applyAria($tip, $t);
				this._getContainer().append($tip);
			}
			return $tip;
		},

		_applyAria: function ($tip, $trigger) {

			if (!$tip.attr('id')) {

				$tip.attr({
					'id': 'mk-tooltip-' + (__id++),
					'role': 'tooltip',
					'aria-hidden': 'true'
				});
				$trigger.attr('aria-describedby', $tip.attr('id'));
			}

			if ($trigger.attr('data-toggle') == 'click') {
				this._applyAriaDialog($tip, $trigger);
			}
		},

		_applyAriaDialog: function ($tip, $trigger) {

			$trigger.attr({
				'id': 'mk-tooltip-' + (__id++),
				'aria-haspopup': 'true'
			});

			$tip.attr({
				'role': 'dialog',
				'tabindex': '-1',
				'aria-labelledby': $trigger.attr('id')
			});
		},

		_position: function ($tip, $trigger, xy) {

			var display = $tip.attr('data-display') || '',
				rtl = this._rtl.test(display),
				rev = this._rev.test(display),
				win = $(window),

				tg = {
					width: $trigger.width(),
					height: $trigger.height(),
					offset: $trigger.offset()
				},
				tp = {
					width: $tip.outerWidth(),
					widthM: $tip.outerWidth(true),
					height: $tip.outerHeight(),
					heightM: $tip.outerHeight(true)
				};

			xy = xy || {};

			//set x if x is not being passed in directly
			if (!xy.x && xy.x !== 0) {
				this._positionX(rtl, tg, tp, xy, win, $tip);
			}
			//set Y if y is not being passed in directly
			if (!xy.y && xy.y !== 0) {
				this._positionY(rtl, rev, tg, tp, xy, win, $tip);
			}
			//apply
			$tip.css({ left: xy.x, top: xy.y });
		},

		_positionX: function (rtl, tg, tp, xy, win, $tip) {

			if (rtl) {
				//left/right vs. top bottom...
				return this._xRtl(tg, tp, xy, $tip);
			}
			//top/bottom positioning...
			this._xStandard(tg, tp, xy, win, $tip);
		},

		_xRtl: function (tg, tp, xy, $tip) {

			//position to the left of the trigger...
			xy.x = tg.offset.left - tp.widthM - ((tp.widthM - tp.width) / 2);
			$tip.addClass('rtl left');

			//position to the right if no room on the left...
			if (xy.x < this._spacer) {
				xy.x = tg.offset.left + tg.width + ((tp.widthM - tp.width) / 2);
				$tip.removeClass('left').addClass('right');
			}
		},

		_xStandard: function (tg, tp, xy, win, $tip) {

			//try centering...
			xy.x = tg.offset.left + (tg.width / 2);
			xy.x = xy.x - (tp.widthM / 2);

			//if not enough left space...
			if (xy.x <= this._spacer) {
				xy.x = tg.offset.left - ((tp.widthM - tp.width) / 2);
				$tip.addClass('left');
			}

			//if tooltip exceeds right space...
			if (xy.x + tp.width > win.width() - this._spacer) {
				xy.x = tg.offset.left + tg.width - (tp.width + ((tp.widthM - tp.width) / 2));
				$tip.removeClass('left').addClass('right');
			}
		},

		_positionY: function (rtl, rev, tg, tp, xy, win, $tip) {

			if (rtl) {
				//position completely different for right-to-left
				return this._yRtl(tg, tp, xy, win, $tip);
			}

			//if reverse, flip logic...
			if (rev) {
				//try bottom first...
				this._yBottom(tg, tp, xy, $tip);
				//fallback to top...
				if (win.height() <= xy.y + this._spacer) {
					this._yTop(tg, tp, xy, $tip);
				}
				return;
			}
			//try top first...
			this._yTop(tg, tp, xy, $tip);
			//fallback to bottom...
			if (win.scrollTop() >= xy.y + this._spacer) {
				this._yBottom(tg, tp, xy, $tip);
			}
		},

		_yTop: function (tg, tp, xy, $tip) {
			xy.y = tg.offset.top - tp.heightM;
			$tip.removeClass('reverse');
		},

		_yBottom: function (tg, tp, xy, $tip) {
			xy.y = tg.offset.top + tg.height;
			$tip.addClass('reverse');
		},

		_yRtl: function (tg, tp, xy, win, $tip) {

			//try center first...
			xy.y = tg.offset.top + (tg.height / 2) - (tp.heightM / 2);
			$tip.addClass('rtl');

			//try bottom...
			if (xy.y <= this._spacer) {
				xy.y = tg.offset.top - (tp.heightM - tp.height);
				$tip.addClass('top');
			}

			//fallback to top...
			if ((xy.y + tp.heightM) >= (win.height() - this._spacer)) {
				xy.y = tg.offset.top - tp.height + (tp.heightM - tp.height);
				$tip.removeClass('top').addClass('bottom');
			}
		},

		bind: function () {

			var self = this;

			this.$container.on(
				'mouseover.mk-tooltip, focus.mk-tooltip', '.mk-tooltip-trigger', function (e) {
					self._over(e);
				})
			.on(
				'mouseout.mk-tooltip, blur.mk-tooltip',	'.mk-tooltip-trigger', function (e) {
					self._out(e);
				})
			.on(
				'click.mk-tooltip', '.mk-tooltip-trigger', function (e) {
					self._click(e);
				})
			.on(
				'mousedown.mk-tooltip', function (e) {
					self._down(e);
				});
		},

		show: function (el, xy) {

			var $t = this._findTrigger(el),
				$tip = this._findTooltip($t);

			$tip.addClass('visible');
			$tip.attr('aria-hidden', 'false');

			this._position($tip, $t, xy);

			if ($t.attr('data-toggle') == 'click') {
				if (!($t.attr('data-prevent-focus') === 'true')) {
					
					var $firstInput = $tip.find('input:first');
					
                    if ($firstInput.length > 0)
                    {
                        $firstInput.focus();
                    }
                    else
                    {
                        $tip.focus();
                    }
				}
			}

			var me = this;
			$(window).one('resize.mk-tooltip', function () {
				me.hide();
			});
		},

		hide: function (el) {

			$(window).off('resize.mk-tooltip');

			if (el == undefined) return this.hideAll();

			var $trigger = this._findTrigger(el),
				$tip = $('#' + $trigger.attr('aria-describedby'));
			if ($tip.find('.button-cancel').length > 0 && $tip.is(':visible')) {$trigger.focus();}
			$tip.removeClass('reverse left right visible rtl top bottom');
			$tip.css({ left: 'auto', top: 'auto' });
			$tip.attr('aria-hidden', 'true');
			
			return this;
		},

		hideAll: function (el) {

			this._getContainer().find('.mk-tooltip').each(function () {
				$(this).removeClass('reverse left right visible rtl top bottom')
					.css({ left: 'auto', top: 'auto' })
					.attr('aria-hidden', 'true');
			});
			return this;
		}
	};

	$.FED = $.FED || {};
	$.FED.Tooltip = Tooltip;

	$.fn.mktooltip = function () {
		return this.each(function () {

			var $container = $(this);

			$container.data('mk-tooltip',
				$container.data('mk-tooltip') || new Tooltip($container));
		});
	};

	$(function () {
		$(document.body).mktooltip();
	});

}(window.jQuery);